import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { ICountryRepository } from '../entities/ICountryRepository';
import { Country } from '../entities';
import { countryDTOToCountryAdapter } from './';

class CountryRepositoryImpl implements ICountryRepository {
  constructor() {
    this.GetCountries = this.GetCountries.bind(this);
  }

  GetCountries(): Promise<Country[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/public/accounts/parameters/countries',
        dataAdapter: countryDTOToCountryAdapter,
      },
    });
  }
}

export { CountryRepositoryImpl };
